import { NavLink } from "react-router-dom";

import { cn } from "@/lib/cn";

interface BottomNavItem {
  to: string;
  label: string;
  glyph: string;
  badge?: number;
}

interface BottomNavProps {
  items: BottomNavItem[];
}

/** Mobile cockpit bottom-nav (brief §9, reference image 5). Visible
 *  only at < lg breakpoints, sticky at the bottom of the viewport so
 *  the single-thumb focus-and-advance flow always has navigation in
 *  reach. */
export function BottomNav({ items }: BottomNavProps) {
  return (
    <nav
      data-testid="bottom-nav"
      aria-label="Cockpit navigation"
      className="sticky bottom-0 z-10 flex w-full items-center justify-between border-t border-op-border bg-op-surface px-1 py-2 lg:hidden"
    >
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end
          className={({ isActive }) =>
            cn(
              "relative flex flex-1 flex-col items-center gap-0.5 rounded px-2 py-1 text-[10px] uppercase tracking-wider transition-colors",
              isActive
                ? "text-op-primary"
                : "text-op-secondary",
            )
          }
          data-testid={`bottom-nav-${item.to.replace(/\//g, "") || "home"}`}
        >
          <span aria-hidden className="text-lg leading-none">
            {item.glyph}
          </span>
          <span>{item.label}</span>
          {item.badge && item.badge > 0 ? (
            <span
              className="absolute right-1 top-1 rounded-full bg-bucket-need-reply-now/20 px-1.5 font-mono text-[10px] text-bucket-need-reply-now"
              aria-label={`${item.badge} items`}
            >
              {item.badge}
            </span>
          ) : null}
        </NavLink>
      ))}
    </nav>
  );
}
